import type { ConsentWindow } from '../types/sdk'

export const updateGTMConsent = (): void => {
  const win = window as ConsentWindow

  if (win?.dataLayer) {
    win.dataLayer.push({ event: 'client-consent-update' })
  }
}
